import { render, staticRenderFns } from "./ImportCompany.vue?vue&type=template&id=91abd66a&"
import script from "./ImportCompany.vue?vue&type=script&lang=ts&"
export * from "./ImportCompany.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports